// ============================================================
// Datei: src/components/deploymentShiftTabs/DeploymentShiftTabs.jsx
//
// PURPOSE:
// - Zentrale Tab-Komponente für die Deployment-Seite
// - zeigt Aufbau / Festival / Abbau
//
// ÄNDERUNGEN:
// - festivalStartDate ergänzt
// - dieses Datum wird an TimelineShiftOverview weitergegeben
// - Aufbau/Abbau können dadurch ihre Tagesdaten berechnen
//
// WICHTIG:
// - Festival verwendet weiterhin die bestehende ShiftOverview
// - Aufbau und Abbau verwenden TimelineShiftOverview
// - bestehende Festival-Funktionen bleiben unverändert
// ============================================================

import React, { useState } from "react";
import ShiftOverview from "../shiftOverview/ShiftOverview";
import ShiftOverviewMobile from "../shiftOverview/ShiftOverviewMobile";
import TimelineShiftOverview from "./TimelineShiftOverview";
import "./deploymentShiftTabs.css";

const SHIFT_TABS = {
	SETUP: "SETUP",
	FESTIVAL: "FESTIVAL",
	TEARDOWN: "TEARDOWN"
};

// ============================================================
// FESTIVAL STARTDATUM
// ============================================================
const DEFAULT_FESTIVAL_START_DATE = "2026-06-19";

const DeploymentShiftTabs = ({
	shifts = [],
	assignedShifts = [],
	handleJoinShift,
	isMobile = false,

	// Optional: Falls du das Startdatum später vom Backend/App-State
	// übergeben möchtest, kann es direkt als Prop gesetzt werden.
	festivalStartDate = DEFAULT_FESTIVAL_START_DATE
}) => {

	// ============================================================
	// STATE
	// Festival ist die Ausgangslage beim Betreten der Seite.
	// ============================================================
	const [activeShiftTab, setActiveShiftTab] = useState(SHIFT_TABS.FESTIVAL);

	const renderActiveContent = () => {
		if (activeShiftTab === SHIFT_TABS.SETUP) {
			return (
				<TimelineShiftOverview
					title="Aufbauwoche"
					phase="AUFBAU"
					festivalStartDate={festivalStartDate}
					shifts={shifts}
					assignedShifts={assignedShifts}
					handleJoinShift={handleJoinShift}
				/>
			);
		}

		if (activeShiftTab === SHIFT_TABS.TEARDOWN) {
			return (
				<TimelineShiftOverview
					title="Abbauwoche"
					phase="ABBAU"
					festivalStartDate={festivalStartDate}
					shifts={shifts}
					assignedShifts={assignedShifts}
					handleJoinShift={handleJoinShift}
				/>
			);
		}

		// ============================================================
		// Bestehende Festival-Ansicht.
		// Diese Logik bleibt bewusst unverändert.
		// ============================================================
		if (isMobile) {
			return (
				<ShiftOverviewMobile
					shifts={shifts}
					assignedShifts={assignedShifts}
					handleJoinShift={handleJoinShift}
				/>
			);
		}

		return (
			<ShiftOverview
				shifts={shifts}
				assignedShifts={assignedShifts}
				handleJoinShift={handleJoinShift}
			/>
		);
	};

	return (
		<div className="deployment-shift-tabs-wrapper">

			<div className="deployment-shift-tabs">
				<button
					type="button"
					className={`deployment-shift-tab ${activeShiftTab === SHIFT_TABS.SETUP ? "active" : ""}`}
					onClick={() => setActiveShiftTab(SHIFT_TABS.SETUP)}
				>
					Aufbau
				</button>

				<button
					type="button"
					className={`deployment-shift-tab ${activeShiftTab === SHIFT_TABS.FESTIVAL ? "active" : ""}`}
					onClick={() => setActiveShiftTab(SHIFT_TABS.FESTIVAL)}
				>
					Festival
				</button>

				<button
					type="button"
					className={`deployment-shift-tab ${activeShiftTab === SHIFT_TABS.TEARDOWN ? "active" : ""}`}
					onClick={() => setActiveShiftTab(SHIFT_TABS.TEARDOWN)}
				>
					Abbau
				</button>
			</div>

			<div className="deployment-shift-tab-content">
				{renderActiveContent()}
			</div>
		</div>
	);
};

export default DeploymentShiftTabs;